function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: "auto",
		direction: "vertical",
		navigation: false,
	};
}

function initSectionMediaSliders(sectionElement, isUpdate = false) {
	if (!sectionElement) return

	const sliderEl = sectionElement.querySelector('.js-media-list')
	const subSliderEl = sectionElement.querySelector('.js-media-sublist')

	if (!sliderEl || !subSliderEl) return

	const subSlider = new Swiper(subSliderEl, {
		slidesPerView: 'auto',
		spaceBetween: 8,
		direction: 'horizontal',
		freeMode: true,
		watchSlidesProgress: true,
		on: {
			touchEnd: function (s) {
				let range = 5
				let diff = (s.touches.diff = s.isHorizontal()
					? s.touches.currentX - s.touches.startX
					: s.touches.currentY - s.touches.startY)
				if (diff < range || diff > -range) s.allowClick = true
			},
		},
		breakpoints: {
			1100: {
				direction: subSliderEl.dataset.thumbnail,
				slidesPerView: 'auto',
			},
		},
	})

	const slider = new Swiper(sliderEl, {
		slidesPerView: 1,
		navigation: {
			nextEl: sliderEl.querySelector('.swiper-btn--next'),
			prevEl: sliderEl.querySelector('.swiper-btn--prev'),
		},
		thumbs: {
			swiper: subSlider,
		},
		on: {
			slideChangeTransitionStart: function () {
				subSlider.slideTo(this.activeIndex)
			},
			slideChange: function () {
				window.pauseAllMedia()
				this.params.noSwiping = false
			},
			slideChangeTransitionEnd: function () {
				if (this.slides[this.activeIndex].querySelector('model-viewer')) {
					this.slides[this.activeIndex]
						.querySelector('.shopify-model-viewer-ui__button--poster')
						.removeAttribute('hidden')
				}
			},
			touchStart: function () {
				if (this.slides[this.activeIndex].querySelector('model-viewer')) {
					if (
						!this.slides[this.activeIndex]
							.querySelector('model-viewer')
							.classList.contains('shopify-model-viewer-ui__disabled')
					) {
						this.params.noSwiping = true
						this.params.noSwipingClass = 'swiper-slide'
					} else {
						this.params.noSwiping = false
					}
				}
			},
		},
	})

	if (isUpdate) {
		setTimeout(function () {
			subSlider.update()
			slider.update()
		}, 800)
	}
}

function loadScriptFromContainerIfNeeded(container, partialSrc) {
	if (!container) return

	const scriptEl = container.querySelector(`script[src*="${partialSrc}"]`)
	if (!scriptEl) return

	const scriptSrc = scriptEl.getAttribute('src')
	if (!scriptSrc || document.querySelector(`script[src="${scriptSrc}"]`)) return

	const nextScriptEl = document.createElement('script')
	nextScriptEl.src = scriptSrc
	nextScriptEl.defer = true
	document.head.appendChild(nextScriptEl)
}

function syncMainProductSectionFromCurrentUrl(sectionElement) {
	if (!sectionElement || sectionElement.dataset.syncProductUrl !== 'true') return
	if (sectionElement.dataset.syncingFromUrl === 'true') return

	const currentUrl = new URL(window.location.href)
	const sectionProductUrl = sectionElement.dataset.productUrl
	if (!sectionProductUrl) return

	const sectionUrl = new URL(sectionProductUrl, window.location.origin)
	if (sectionUrl.pathname === currentUrl.pathname) return

	const sectionId = sectionElement.dataset.section?.trim()
	if (!sectionId) return

	sectionElement.dataset.syncingFromUrl = 'true'

	const requestUrl = new URL(currentUrl.toString())
	requestUrl.searchParams.set('section_id', sectionId)

	fetch(requestUrl.toString())
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html')
			const nextSection = html.getElementById(`MainProduct-${sectionId}`)
			if (!nextSection) return

			sectionElement.innerHTML = nextSection.innerHTML
			if (nextSection.dataset.productUrl) {
				sectionElement.dataset.productUrl = nextSection.dataset.productUrl
			}

			if (window.Shopify?.PaymentButton) {
				window.Shopify.PaymentButton.init()
			}

			loadScriptFromContainerIfNeeded(sectionElement, 'recipient-form.js')
			initSectionMediaSliders(sectionElement, true)
		})
		.catch((error) => {
			console.error(error)
		})
		.finally(() => {
			delete sectionElement.dataset.syncingFromUrl
		})
}

function syncMainProductSectionsFromCurrentUrl() {
	document
		.querySelectorAll('section[id^="MainProduct-"][data-sync-product-url="true"]')
		.forEach((sectionElement) => {
			syncMainProductSectionFromCurrentUrl(sectionElement)
		})
}

window.addEventListener('pageshow', syncMainProductSectionsFromCurrentUrl)
requestAnimationFrame(() => {
	syncMainProductSectionsFromCurrentUrl()
})

const sliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-list") &&
		document.querySelectorAll(".product-section .js-media-list").length > 0
	) {
		let slider = new Swiper(".product-section .js-media-list", {
			slidesPerView: 1,
			navigation: {
				nextEl: ".swiper-btn--next",
				prevEl: ".swiper-btn--prev",
			},
			thumbs: {
				swiper: document.querySelector(".product-section .js-media-sublist")
					.swiper,
			},
			on: {
				slideChangeTransitionStart: function () {
					document
						.querySelector(".product-section .js-media-sublist")
						.swiper.slideTo(
							document.querySelector(".product-section .js-media-list").swiper
								.activeIndex
						);
				},
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						} else {
							this.params.noSwiping = false;
						}
					}
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				slider.update();
			}, 800);
		}
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-sublist") &&
		document.querySelectorAll(".product-section .js-media-sublist").length > 0
	) {
		let thumbnail_alignment = document.querySelector(
			".product-section .js-media-sublist"
		);
		let subSlider = new Swiper(".product-section .js-media-sublist", {
			slidesPerView: "auto",
			spaceBetween: 8,
			direction: "horizontal",
			freeMode: true,
			watchSlidesProgress: true,
			on: {
				touchEnd: function (s, e) {
					let range = 5;
					let diff = (s.touches.diff = s.isHorizontal()
						? s.touches.currentX - s.touches.startX
						: s.touches.currentY - s.touches.startY);
					if (diff < range || diff > -range) s.allowClick = true;
				},
			},
			transitionStart: function () {
				document
					.querySelector(".product-section .js-media-list")
					.swiper.slideTo(
						document.querySelector(".product-section.js-media-sublist").swiper
							.activeIndex
					);
			},
			breakpoints: {
				1100: {
					direction: thumbnail_alignment.dataset.thumbnail,
					slidesPerView: "auto",
				},
			},
		});

		if (isUpdate) {
			setTimeout(function () {
				subSlider.update();
			}, 800);
		}
	}
};

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom"
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		let isOpen = false;

		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
			"click",
			this.loadContent.bind(this)
		);
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);

			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);
			//if (focus) deferredElement.focus();
			//console.log(deferredElement, "deferredElement.nodeName");
			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				// force autoplay for safari
				deferredElement.play();
			}

			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
							this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		if (!this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

//class VariantSelects extends HTMLElement {
//	constructor() {
//		super();
//		this.addEventListener("change", this.onVariantChange);
//	}

//	onVariantChange() {
//		this.updateOptions();
//		this.updateMasterId();
//		this.toggleAddButton(true, "", false);
//		this.updatePickupAvailability();
//		this.updateVariantStatuses();

//		if (!this.currentVariant) {
//			this.toggleAddButton(true, "", true);
//			this.setUnavailable();
//		} else {
//			this.updateMediaSub();
//			if (
//				this.currentVariant?.featured_media &&
//				this.dataset?.variantMediaDisplay === 'show_all'
//			) {
//				this.updateMedia()
//			}
//			this.updateURL();
//			this.updateVariantInput();
//			this.renderProductInfo();
//		}

//		if (this.currentVariant) {
//			document.dispatchEvent(
//				new CustomEvent('variant:change', {
//					detail: {
//						variant: this.currentVariant,
//						previousVariant: this.previousVariant || null,
//						formElement: document.querySelector(
//							`#${this.getAttribute('id')}`
//						),
//						sectionId: this.dataset.section,
//					},
//				})
//			)

//			// Save the previous version
//			this.previousVariant = this.currentVariant
//		}
//	}

//	updateOptions() {
//		const options = [];
//		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));
//		const selects = this.querySelectorAll("select");

//		for (const fieldset of fieldsets) {
//			const radioValue = Array.from(fieldset.querySelectorAll("input")).find(
//				(radio) => radio.checked
//			).value;

//			options.push(radioValue);
//		}

//		for (const select of selects) {
//			options.push(select.value);
//		}
//		this.options = options;
//	}

//	updateMasterId() {
//		if (this.variantData || this.querySelector('[type="application/json"]')) {
//			this.currentVariant = this.getVariantData().find((variant) => {
//				//this.options.sort();
//				//variant.options.sort();

//				return !variant.options
//					.map((option, index) => {
//						return this.options[index] === option;
//					})
//					.includes(false);
//			});
//		}
//	}

//	updateMedia() {
//		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

//		const newMedia = document.querySelector(
//			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
//		);

//		if (!newMedia) return;

//		const parent = newMedia.parentElement;

//		parent.prepend(newMedia);

//		window.setTimeout(() => {
//			parent.scroll(0, 0);
//		});

//		if (document.querySelector(".js-media-list")) {
//			sliderInit();
//		}
//	}

//	updateMediaSub() {
//		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

//		const newMediaSub = document.querySelector(
//			`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
//		);

//		if (
//			document.querySelector(".js-media-sublist") &&
//			document.querySelector(".js-media-sublist").swiper != null
//		) {
//			document.querySelector(".js-media-sublist").swiper.destroy();
//		}

//		if (!newMediaSub) return;

//		const parentSub = newMediaSub.parentElement;

//		parentSub.prepend(newMediaSub);

//		window.setTimeout(() => {
//			parentSub.scroll(0, 0);
//		});

//		if (document.querySelector(".js-media-sublist")) {
//			subSliderInit();
//		}
//	}

//	updateURL() {
//		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
//		window.history.replaceState(
//			{},
//			"",
//			`${this.dataset.url}?variant=${this.currentVariant.id}`
//		);
//	}

//	updateVariantInput() {
//		const productForms = document.querySelectorAll(
//			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
//		);
//		productForms.forEach((productForm) => {
//			const input = productForm.querySelector('input[name="id"]');
//			input.value = this.currentVariant.id;
//			input.dispatchEvent(new Event("change", { bubbles: true }));
//		});
//	}

//	updateVariantStatuses() {
//		const selectedOptionOneVariants = this.variantData.filter(
//			(variant) => this.querySelector(":checked").value === variant.option1
//		);
//		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
//		inputWrappers.forEach((option, index) => {
//			if (index === 0) return;
//			const optionInputs = [
//				...option.querySelectorAll('input[type="radio"], option'),
//			];
//			const previousOptionSelected =
//				inputWrappers[index - 1].querySelector(":checked").value;
//			const availableOptionInputsValue = selectedOptionOneVariants
//				.filter(
//					(variant) =>
//						variant.available &&
//						variant[`option${index}`] === previousOptionSelected
//				)
//				.map((variantOption) => variantOption[`option${index + 1}`]);
//			this.setInputAvailability(optionInputs, availableOptionInputsValue);
//		});
//	}

//	setInputAvailability(listOfOptions, listOfAvailableOptions) {
//		listOfOptions.forEach((input) => {
//			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
//				if (input.tagName === "OPTION") {
//					input.innerText = input.getAttribute("value");
//				} else if (input.tagName === "INPUT") {
//					input.classList.remove("disabled");
//				}
//			} else {
//				if (input.tagName === "OPTION") {
//					input.innerText =
//						window.variantStrings.unavailable_with_option.replace(
//							"[value]",
//							input.getAttribute("value")
//						);
//				} else if (input.tagName === "INPUT") {
//					input.classList.add("disabled");
//				}
//			}
//		});
//	}

//	updatePickupAvailability() {
//		const pickUpAvailability = document.querySelector("pickup-availability");
//		if (!pickUpAvailability) return;

//		if (this.currentVariant && this.currentVariant.available) {
//			pickUpAvailability.fetchAvailability(this.currentVariant.id);
//		} else {
//			pickUpAvailability.removeAttribute("available");
//			pickUpAvailability.innerHTML = "";
//		}
//	}

//	renderProductInfo() {
//		const requestedVariantId = this.currentVariant.id;
//		const sectionId = this.dataset.originalSection
//			? this.dataset.originalSection
//			: this.dataset.section;

//		fetch(
//			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
//				this.dataset.originalSection
//					? this.dataset.originalSection
//					: this.dataset.section
//			}`
//		)
//			.then((response) => response.text())
//			.then((responseText) => {
//				// prevent unnecessary ui changes from abandoned selections
//				if (this.currentVariant.id !== requestedVariantId) return

//				const html = new DOMParser().parseFromString(responseText, 'text/html')
//				const destination = document.getElementById(
//					`price-${this.dataset.section}`
//				)
//				const source = html.getElementById(
//					`price-${
//						this.dataset.originalSection
//							? this.dataset.originalSection
//							: this.dataset.section
//					}`
//				)
//				const skuSource = html.getElementById(
//					`Sku-${
//						this.dataset.originalSection
//							? this.dataset.originalSection
//							: this.dataset.section
//					}`
//				)
//				const skuDestination = document.getElementById(
//					`Sku-${this.dataset.section}`
//				)
//				const inventorySource = html.getElementById(
//					`Inventory-${
//						this.dataset.originalSection
//							? this.dataset.originalSection
//							: this.dataset.section
//					}`
//				)
//				const inventoryDestination = document.getElementById(
//					`Inventory-${this.dataset.section}`
//				)

//				if (source && destination) destination.innerHTML = source.innerHTML
//				if (inventorySource && inventoryDestination)
//					inventoryDestination.innerHTML = inventorySource.innerHTML
//				if (skuSource && skuDestination) {
//					skuDestination.innerHTML = skuSource.innerHTML
//					skuDestination.classList.toggle(
//						'visibility-hidden',
//						skuSource.classList.contains('visibility-hidden')
//					)
//				}

//				const price = document.getElementById(`price-${this.dataset.section}`)

//				if (price) price.classList.remove('visibility-hidden')

//				if (inventoryDestination)
//					inventoryDestination.classList.toggle(
//						'visibility-hidden',
//						inventorySource.innerText === ''
//					)

//				const addButtonUpdated = html.getElementById(
//					`ProductSubmitButton-${sectionId}`
//				)
//				this.toggleAddButton(
//					addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
//					window.variantStrings.soldOut
//				)
				
//				// product media
//				if (this.dataset?.variantMediaDisplay !== 'show_all') {
//					const sourceSectionId = this.dataset.originalSection
//						? this.dataset.originalSection
//						: this.dataset.section
//					const currentSectionId = this.dataset.section

//					const mediaSource = html.querySelector(
//						`[data-section="product-media-${sourceSectionId}"]`
//					)
//					const mediaDestination = document.querySelector(
//						`[data-section="product-media-${currentSectionId}"]`
//					)

//					if (mediaSource && mediaDestination) {
//						mediaDestination.innerHTML = mediaSource.innerHTML

//						const parentQuickView = this.closest('quick-view-modal')
//						if (parentQuickView) {
//							if (typeof parentQuickView.removeDOMElements === 'function') {
//								parentQuickView.removeDOMElements(mediaDestination)
//							}
//							if (typeof parentQuickView.initSlider === 'function') {
//								parentQuickView.initSlider()
//							}
//						} else {
//							const section = document.getElementById(
//								`shopify-section-${currentSectionId}`
//							)

//							if (section && typeof initProductPage === 'function') {
//								initProductPage(section)
//							}
//						}
//						if (document.querySelector('.js-media-list')) {
//							subSliderInit(true)
//							sliderInit(true)
//						}
//					}
//				}
//			});
//	}

//	toggleAddButton(disable = true, text, modifyClass = true) {
//		const productForm = document.getElementById(
//			`product-form-${this.dataset.section}`
//		);
//		if (!productForm) return;
//		const addButton = productForm.querySelector('[name="add"]');
//		const addButtonText = productForm.querySelectorAll('[name="add"] > span');
//		if (!addButton) return;

//		if (disable) {
//			addButton.setAttribute("disabled", "disabled");

//			if (text) {
//				addButtonText.forEach((elem) => {
//					elem.innerHTML = `${text}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
//<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
//</svg>`;
//				});
//			}
//		} else {
//			addButton.removeAttribute("disabled");
//			addButtonText.forEach((elem) => {
//				elem.innerHTML = `${window.variantStrings.addToCart}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
//<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
//</svg>`;
//			});
//		}

//		if (!modifyClass) return;
//	}

//	setUnavailable() {
//		const button = document.getElementById(
//			`product-form-${this.dataset.section}`
//		);
//		const addButton = button.querySelector('[name="add"]');
//		const addButtonText = button.querySelectorAll('[name="add"] > span');
//		const price = document.getElementById(`price-${this.dataset.section}`);
//		const inventory = document.getElementById(
//			`Inventory-${this.dataset.section}`
//		);
//		const sku = document.getElementById(`Sku-${this.dataset.section}`);
//		if (!addButton) return;
//		addButtonText.forEach((elem) => {
//			elem.innerHTML = `${window.variantStrings.unavailable}<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" fill="none">
//<path d="M3.25 6V4.5C3.25 3.50544 3.64509 2.55161 4.34835 1.84835C5.05161 1.14509 6.00544 0.75 7 0.75C7.99456 0.75 8.94839 1.14509 9.65165 1.84835C10.3549 2.55161 10.75 3.50544 10.75 4.5V6H13C13.1989 6 13.3897 6.07902 13.5303 6.21967C13.671 6.36032 13.75 6.55109 13.75 6.75V15.75C13.75 15.9489 13.671 16.1397 13.5303 16.2803C13.3897 16.421 13.1989 16.5 13 16.5H1C0.801088 16.5 0.610322 16.421 0.46967 16.2803C0.329018 16.1397 0.25 15.9489 0.25 15.75V6.75C0.25 6.55109 0.329018 6.36032 0.46967 6.21967C0.610322 6.07902 0.801088 6 1 6H3.25ZM3.25 7.5H1.75V15H12.25V7.5H10.75V9H9.25V7.5H4.75V9H3.25V7.5ZM4.75 6H9.25V4.5C9.25 3.90326 9.01295 3.33097 8.59099 2.90901C8.16903 2.48705 7.59674 2.25 7 2.25C6.40326 2.25 5.83097 2.48705 5.40901 2.90901C4.98705 3.33097 4.75 3.90326 4.75 4.5V6Z" fill="currentColor"/>
//</svg>`;
//		});
//		if (price) price.classList.add("visibility-hidden");
//		if (inventory) inventory.classList.add("visibility-hidden");
//		if (sku) sku.classList.add("visibility-hidden");
//	}

//	getVariantData() {
//		this.variantData =
//			this.variantData ||
//			JSON.parse(this.querySelector('[type="application/json"]').textContent);
//		return this.variantData;
//	}
//}

//customElements.define("variant-selects", VariantSelects);

//class VariantRadios extends VariantSelects {
//	constructor() {
//		super();
//	}

//	setInputAvailability(listOfOptions, listOfAvailableOptions) {
//		listOfOptions.forEach((input) => {
//			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
//				input.classList.remove("disabled");
//			} else {
//				input.classList.add("disabled");
//			}
//		});
//	}

//	updateOptions() {
//		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
//		this.options = fieldsets.map((fieldset) => {
//			return Array.from(fieldset.querySelectorAll("input")).find(
//				(radio) => radio.checked
//			).value;
//		});
//	}
//}

//customElements.define("variant-radios", VariantRadios);

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
		this.boundSyncFromCurrentUrl = this.syncFromCurrentUrl.bind(this)

		this.isHighVariantNeedUpdate = false
		this.isCombinedListingsNeedUpdate = false
	}

	connectedCallback() {
		if (this.dataset.updateUrl !== 'true' || this.dataset.originalSection) return

		window.addEventListener('pageshow', this.boundSyncFromCurrentUrl)
		requestAnimationFrame(() => {
			this.syncFromCurrentUrl()
		})
	}

	disconnectedCallback() {
		if (this.boundSyncFromCurrentUrl) {
			window.removeEventListener('pageshow', this.boundSyncFromCurrentUrl)
		}
	}

	getOptionControls() {
		return [
			...this.querySelectorAll('.product-form__controls, .product-form__input'),
		].filter((control) => control?.dataset?.optionPosition)
	}

	getSelectedVariantFromDom() {
		const selectedVariantEl = this.querySelector('[data-selected-variant]')
		if (!selectedVariantEl?.textContent) return null

		try {
			return JSON.parse(selectedVariantEl.textContent)
		} catch (error) {
			return null
		}
	}

	buildSectionRequestUrl() {
		const sectionId = this.dataset.originalSection || this.dataset.section
		const currentUrl = new URL(window.location.href)
		currentUrl.searchParams.set('section_id', sectionId)
		return currentUrl.toString()
	}

	shouldSyncFromCurrentUrl() {
		if (this.dataset.updateUrl !== 'true') return false

		const currentLocation = new URL(window.location.href)
		const pickerUrl = new URL(this.dataset.url || currentLocation.pathname, window.location.origin)
		const urlVariantId = currentLocation.searchParams.get('variant')
		const selectedVariant = this.getSelectedVariantFromDom()
		const selectedVariantId = selectedVariant?.id ? String(selectedVariant.id) : null

		if (pickerUrl.pathname !== currentLocation.pathname) return true
		if (urlVariantId && selectedVariantId !== urlVariantId) return true

		return false
	}

	syncFromCurrentUrl() {
		if (!this.isConnected || this.isSyncingFromCurrentUrl) return
		if (!this.shouldSyncFromCurrentUrl()) return

		this.isSyncingFromCurrentUrl = true

		fetch(this.buildSectionRequestUrl())
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')

				this.setCurrentVariantAfterFetch(html)
				this.updatePickerInnerHtml(html)
				this.updateOptions()
				this.getVariantData()
				this.updatePickupAvailability()
				this.updateVariantStatuses()
				this.updateElementsAfterFetch(html)

				if (!this.currentVariant) {
					this.toggleAddButton(true, '')
					this.setUnavailable()
				} else {
					this.updateVariantInput()
					this.toggleAddButton(
						!this.currentVariant.available,
						window.variantStrings.soldOut,
					)
				}
			})
			.catch((error) => {
				console.error(error)
			})
			.finally(() => {
				this.isSyncingFromCurrentUrl = false
			})
	}

	onVariantChange(event) {
		if (!this.contains(event.target)) return
		if (event.target?.name === 'quantity') return

		const combinedProductURL = event.target.dataset?.productUrl

		this.updateOptions()
		// updateMasterId method updates currentVariant from liquid <script data-all-variations-no-high>
		this.updateMasterId()
		this.toggleAddButton(true, '')

		this.isHighVariantNeedUpdate = false
		this.isCombinedListingsNeedUpdate = false
		// -----
		// checking for high-variant and combined products
		// if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
		if (
			(!this.currentVariant && this.dataset.isHighVariantProduct === 'true') ||
			(!this.currentVariant && combinedProductURL)
		) {
			const selectedValuesIds = this.getSelectedValuesIds()
			this.highVariantRequestUrl = this.createRequestUrl({
				selectedValuesIds: selectedValuesIds,
				combinedProductURL: combinedProductURL,
			})
			if (this.highVariantRequestUrl) {
				this.isHighVariantNeedUpdate = true
				if (combinedProductURL) {
					this.isCombinedListingsNeedUpdate = true
				}
			}
		}
		// -----

		if (this.isHighVariantNeedUpdate === false) {
			this.updatePickupAvailability()
			this.updateVariantStatuses()
		}
		this.resetErrorMessage()

		if (!this.currentVariant) {
			// -----
			// for high-variant products
			if (this.isHighVariantNeedUpdate) {
				this.classList.add('high-variant-loading')
				this.renderProductInfo(this.highVariantRequestUrl)
				return
			}
			// -----

			this.toggleAddButton(true, '')
			this.setUnavailable()
		} else {
			if (
				this.currentVariant?.featured_media &&
				this.dataset?.variantMediaDisplay === 'show_all'
			) {
				// If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
				const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`
				this.updateMedia(mediaId)
			}
			this.updateURL()
			this.updateVariantInput()
			const requestUrl = this.createRequestUrl({
				currentVariantId: this.currentVariant.id,
			})
			this.renderProductInfo(requestUrl)
		}
	}

	updateOptions() {
		const fieldsets = Array.from(
			this.querySelectorAll(
				'.product-form__controls--dropdown, .product-form__input--dropdown',
			),
		)

		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value,
		).concat(
			fieldsets.map((fieldset) => {
				const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find(
					(radio) => radio.checked,
				)
				return checkedRadio ? checkedRadio.value : null
			}),
		)
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[data-all-variants-no-high]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option
					})
					.includes(false)
			})
		}
	}

	isHidden(elem) {
		const styles = window.getComputedStyle(elem)
		return styles.display === 'none' || styles.visibility === 'hidden'
	}

	getMediaSourceElement(html, sectionId) {
		if (!html) return null

		return (
			html.querySelector(`[data-section="product-media-${sectionId}"]`) ||
			html.querySelector('.product__media-list-wrapper')
		)
	}

	getMediaDestinationElement(sectionId) {
		return (
			document.querySelector(`[data-section="product-media-${sectionId}"]`) ||
			this.closest('.product')?.querySelector('.product__media-list-wrapper')
		)
	}

	getMediaSourceWrapper(html, sectionId) {
		return (
			this.getMediaSourceElement(html, sectionId)?.closest('.product__media-wrapper') ||
			html?.querySelector('.product__media-wrapper')
		)
	}

	getMediaDestinationWrapper(sectionId) {
		return (
			this.getMediaDestinationElement(sectionId)?.closest('.product__media-wrapper') ||
			this.closest('.product')?.querySelector('.product__media-wrapper')
		)
	}

	updateMediaModalContent(html, sourceSectionId, currentSectionId) {
		const modalSource = html.getElementById(`ProductModal-${sourceSectionId}`)
		const modalDestination = document.getElementById(
			`ProductModal-${currentSectionId}`,
		)

		if (!modalSource || !modalDestination) return

		const modalContentSource = modalSource.querySelector(
			'.product-media-modal__content',
		)
		const modalContentDestination = modalDestination.querySelector(
			'.product-media-modal__content',
		)

		if (!modalContentSource || !modalContentDestination) return

		modalContentDestination.innerHTML = modalContentSource.innerHTML
	}

	loadRecipientFormScriptIfNeeded(container) {
		if (!container || customElements.get('recipient-form')) return

		const recipientFormScript = container.querySelector(
			'script[src*="recipient-form.js"]',
		)
		if (!recipientFormScript) return

		const scriptSrc = recipientFormScript.getAttribute('src')
		if (!scriptSrc || document.querySelector(`script[src="${scriptSrc}"]`)) return

		const scriptEl = document.createElement('script')
		scriptEl.src = scriptSrc
		scriptEl.defer = true
		document.head.appendChild(scriptEl)
	}

	updateBuyButtons(html, sourceSectionId, currentSectionId) {
		const buyButtonsSource = html.getElementById(`BuyButtons-${sourceSectionId}`)
		const buyButtonsDestination = document.getElementById(
			`BuyButtons-${currentSectionId}`,
		)

		if (!buyButtonsDestination) return

		buyButtonsDestination.innerHTML = buyButtonsSource
			? buyButtonsSource.innerHTML
			: ''

		if (window.Shopify?.PaymentButton) {
			window.Shopify.PaymentButton.init()
		}

		this.loadRecipientFormScriptIfNeeded(buyButtonsDestination)
	}

	updateMedia(mediaId) {
		if (!mediaId) return

		const mediaEl = this.getMediaDestinationElement(this.dataset.section)
		if (!mediaEl) return

		// for slider and slider_previews layout
		const sliderEl = mediaEl.querySelector('.js-media-list')
		if (sliderEl && sliderEl.swiper) {
			sliderEl.querySelectorAll('.swiper-slide').forEach((slide, index) => {
				const slideMediaId = slide.dataset?.mediaId
				if (slideMediaId === mediaId) {
					const findIndex = sliderEl.swiper.slides.findIndex((slideEl) => {
						return slideEl.dataset?.mediaId === slideMediaId
					})
					const fallbackIndex = Number(slide.dataset?.swiperSlideIndex || index)
					const swiperSlideIndex = findIndex !== -1 ? findIndex : fallbackIndex
					sliderEl.swiper.slideTo(swiperSlideIndex, 800)
				}
			})
		}
	}

	updateURL() {
		if (this.dataset.updateUrl === 'false') return
		const newUrl = this.currentVariant
			? `${this.dataset.url}?variant=${this.currentVariant.id}`
			: this.dataset.url

		window.history.replaceState({}, '', newUrl)
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', {bubbles: true}))
		})

		publish(PUB_SUB_EVENTS.variantChange, {
			data: {
				sectionId: this.dataset.section,
				variant: this.currentVariant,
			},
		})
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.options[0],
		)
		const inputWrappers = this.getOptionControls()
		inputWrappers.forEach((option, index) => {
			if (index === 0) return
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			]
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(':checked').value
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant.options[index - 1] === previousOptionSelected,
				)
				.map((variantOption) => variantOption.options[index])
			this.setInputAvailability(optionInputs, availableOptionInputsValue)
		})
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				if (input.tagName === 'OPTION') {
					input.innerText = input.getAttribute('value')
				} else if (input.tagName === 'INPUT') {
					input.classList.remove('disabled')
				}
			} else {
				if (input.tagName === 'OPTION') {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							'[value]',
							input.getAttribute('value'),
						)
				} else if (input.tagName === 'INPUT') {
					input.classList.add('disabled')
				}
			}
		})
	}

	setCheckedInputsBySelectedValues(selectedValues) {
		const inputWrappers = this.getOptionControls()

		inputWrappers.forEach((groupEl, index) => {
			const selectedValue = selectedValues[index]
			if (!selectedValue) return

			const inputs = [...groupEl.querySelectorAll('input[type="radio"]')]

			inputs.forEach((input) => {
				const shouldBeChecked = input.value === selectedValue
				input.checked = shouldBeChecked
				if (shouldBeChecked) {
					input.setAttribute('checked', '')
				} else {
					input.removeAttribute('checked')
				}
			})
		})
	}

	getSelectedValues() {
		const controls = this.getOptionControls()

		controls.sort((a, b) => {
			return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
		})

		const selectedValues = controls.map((control) => {
			const checkedInput = control.querySelector('input[type="radio"]:checked')
			return checkedInput ? checkedInput.value : null
		})

		return selectedValues
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability')
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute('available')
			pickUpAvailability.innerHTML = ''
		}
	}

	renderProductInfo(requestUrl) {
		this.abortController?.abort()
		this.abortController = new AbortController()

		fetch(requestUrl, {signal: this.abortController.signal})
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')

				try {
					this.setCurrentVariantAfterFetch(html)
				} catch (err) {}

				// -----
				// for high-variant products
				// and if variant not found in liquid <script data-all-variants-no-high>
				// but it was found after a request with the option_values parameter
				if (this.isHighVariantNeedUpdate) {
					try {
						this.updateURL()
						this.updatePickupAvailability()
						this.updatePickerInnerHtml(html)
						if (this.currentVariant) {
							this.updateVariantInput()
							if (
								this.currentVariant.featured_media &&
								this.dataset?.variantMediaDisplay === 'show_all'
							) {
								// If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
								const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`
								this.updateMedia(mediaId)
							}
						}
					} catch (err) {}
				}
				// -----

				this.updateElementsAfterFetch(html)

				if (!this.currentVariant) {
					this.toggleAddButton(true, '')
					this.setUnavailable()
				} else {
					this.toggleAddButton(
						!this.currentVariant.available,
						window.variantStrings.soldOut,
					)
				}
			})
			.catch((error) => {
				if (error.name === 'AbortError') {
					console.info('Fetch aborted by user')
				} else {
					console.error(error)
				}
			})
			.finally(() => {
				this.classList.remove('high-variant-loading')
			})
	}

	toggleAddButton(disable = true, text) {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const addButton = productForm.querySelector('[name="add"]')
			if (!addButton) return

			const addButtonText =
				addButton.querySelector('.button__label') ||
				addButton.querySelector('span')

			if (disable) {
				addButton.setAttribute('disabled', true)
				addButton.setAttribute('aria-disabled', true)
				if (text) {
					if (addButtonText) {
						addButtonText.textContent = text
					}

					if (text === window.variantStrings.unavailable) {
						addButton.dataset.status = 'unavailable'
					} else {
						addButton.dataset.status = 'sold-out'
					}
				}
			} else {
				addButton.removeAttribute('disabled')
				addButton.removeAttribute('aria-disabled')
				if (addButtonText) {
					addButtonText.textContent = window.variantStrings.addToCart
				}
				addButton.dataset.status = 'available'
			}
		})
	}

	resetErrorMessage() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		)
		productForms.forEach((productForm) => {
			const parentEl = productForm.closest('product-form')
			if (parentEl) {
				const errorWrapperEl = parentEl.querySelector(
					'.product-form__error-message-wrapper',
				)
				const errorTextEl = errorWrapperEl?.querySelector(
					'.product-form__error-message',
				)
				if (!errorWrapperEl || !errorTextEl) return
				errorWrapperEl.setAttribute('hidden', true)
				errorTextEl.textContent = ''
			}
		})
	}

	setUnavailable() {
		const price = document.getElementById(`price-${this.dataset.section}`)
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`,
		)
		const sku = document.getElementById(`Sku-${this.dataset.section}`)
		const colorNameDestinations = document.querySelectorAll(
			`[id^="ColorName-${this.dataset.section}"]`,
		)

		this.toggleAddButton(true, window.variantStrings.unavailable)
		if (price) price.classList.add('visibility-hidden')
		if (inventory) inventory.classList.add('visibility-hidden')
		if (sku) sku.classList.add('visibility-hidden')
		colorNameDestinations.forEach((colorNameDestination) => {
			colorNameDestination.classList.add('visibility-hidden')
		})
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[data-all-variants-no-high]').textContent)
		return this.variantData
	}

	updateElementsAfterFetch(html) {
		// attr data-original-section use for Quick view modal
		const currentSectionId = this.dataset.section
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		// price
		const priceDestination = document.getElementById(
			`price-${currentSectionId}`,
		)
		
		const priceSource = html.getElementById(`price-${sourceSectionId}`)
		if (priceSource && priceDestination) {
			priceDestination.innerHTML = priceSource.innerHTML
			priceDestination.classList.remove('visibility-hidden')
		}

		// title
		const titleSource = html.getElementById(`ProductTitle-${sourceSectionId}`)
		const titleDestination = document.getElementById(
			`ProductTitle-${currentSectionId}`,
		)
		if (titleSource && titleDestination) {
			titleDestination.innerHTML = titleSource.innerHTML
		}

		// breadcrumb title
		const crumbSource = html.getElementById(
			`ProductBreadcrumbTitle-${sourceSectionId}`,
		)
		const crumbDestination = document.getElementById(
			`ProductBreadcrumbTitle-${currentSectionId}`,
		)
		if (crumbSource && crumbDestination) {
			crumbDestination.textContent = crumbSource.textContent
		}

		// inventory
		const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`)
		const inventoryDestination = document.getElementById(
			`Inventory-${currentSectionId}`,
		)
		if (inventorySource && inventoryDestination) {
			inventoryDestination.innerHTML = inventorySource.innerHTML
			inventoryDestination.classList.toggle(
				'visibility-hidden',
				inventorySource.innerText === '',
			)
		}

		// sku
		const skuSource = html.getElementById(`Sku-${sourceSectionId}`)
		const skuDestination = document.getElementById(`Sku-${currentSectionId}`)
		if (skuSource && skuDestination) {
			skuDestination.innerHTML = skuSource.innerHTML
			skuDestination.classList.toggle(
				'visibility-hidden',
				skuSource.classList.contains('visibility-hidden'),
			)
		}

		// color swatches label
		const colorNameSources = html.querySelectorAll(
			`[id^="ColorName-${sourceSectionId}"]`,
		)
		const colorNameDestinations = document.querySelectorAll(
			`[id^="ColorName-${currentSectionId}"]`,
		)
		if (colorNameSources?.length === colorNameDestinations?.length) {
			colorNameDestinations.forEach((colorNameDestination, index) => {
				colorNameDestination.classList.remove('visibility-hidden')
				colorNameDestination.innerHTML = colorNameSources[index].innerHTML
			})
		}

		// description
		const descriptionSource = html.getElementById(
			`Description-${sourceSectionId}`,
		)
		const descriptionDestination = document.getElementById(
			`Description-${currentSectionId}`,
		)
		if (descriptionDestination) {
			descriptionDestination.innerHTML = descriptionSource
				? descriptionSource.innerHTML
				: ''
		}

		// buy buttons / gift card recipient form
		this.updateBuyButtons(html, sourceSectionId, currentSectionId)

		// complementary products
		const complementarySource = html.getElementById(
			`Complementary-${sourceSectionId}`,
		)
		const complementaryDestination = document.getElementById(
			`Complementary-${currentSectionId}`,
		)
		if (complementaryDestination) {
			complementaryDestination.innerHTML = complementarySource
				? complementarySource.innerHTML
				: ''
		}

		// variant image swatches
		if (this.isHighVariantNeedUpdate !== true) {
			const variantSwatchesSource = html.querySelector(
				`#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`,
			)
			const variantSwatchesDestination = document.querySelector(
				`#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`,
			)
			if (variantSwatchesSource && variantSwatchesDestination) {
				const quickViewModal = this.closest('quick-add-modal')
				if (quickViewModal) {
					variantSwatchesDestination.innerHTML =
						variantSwatchesSource.innerHTML.replaceAll(
							sourceSectionId,
							`quickview-${sourceSectionId}`,
						)
				} else {
					variantSwatchesDestination.innerHTML = variantSwatchesSource.innerHTML
				}
			}
		}

		// product media
		if (
			this.dataset?.variantMediaDisplay !== 'show_all' ||
			this.isCombinedListingsNeedUpdate
		) {
			const mediaSource = this.getMediaSourceWrapper(html, sourceSectionId)
			const mediaDestination = this.getMediaDestinationWrapper(currentSectionId)
			if (mediaSource && mediaDestination) {
				mediaDestination.innerHTML = mediaSource.innerHTML
				this.updateMediaModalContent(html, sourceSectionId, currentSectionId)

				const parentQuickView = this.closest('quick-add-modal')
				if (parentQuickView) {
					if (typeof parentQuickView.removeDOMElements === 'function') {
						parentQuickView.removeDOMElements(mediaDestination)
					}
					if (typeof parentQuickView.initSlider === 'function') {
						parentQuickView.initSlider()
					}
				} else {
					const section = document.getElementById(
						`shopify-section-${currentSectionId}`,
					)

					initSectionMediaSliders(section, true)
				}
			}
		}
	}

	// methods for high variant products
	getSelectedValuesIds() {
		const controls = this.getOptionControls()

		controls.sort((a, b) => {
			return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
		})

		const selectedIds = controls
			.map((control) => {
				const checkedInput = control.querySelector('input[type="radio"]:checked')
				return checkedInput?.dataset?.optionValueId
					? checkedInput.dataset.optionValueId
					: null
			})
			.filter((id) => !!id)

		if (selectedIds.length !== controls.length) return []
		return selectedIds
	}

	createRequestUrl({
		currentVariantId = '',
		selectedValuesIds = [],
		combinedProductURL = '',
	}) {
		const productUrl = combinedProductURL || `${this.dataset.url}`
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		if (currentVariantId) {
			return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`
		}

		// -----
		// for high-variant products
		// and if variant not found in liquid <script data-all-variants-no-high>
		if (selectedValuesIds.length) {
			const params = []
			params.push(`section_id=${sectionId}`)
			params.push(
				`option_values=${selectedValuesIds.map((id) => encodeURIComponent(id)).join(',')}`,
			)
			return `${productUrl}?${params.join('&')}`
		}
		// -----
	}

	setCurrentVariantAfterFetch(html) {
		// attr data-original-section use for Quick view modal
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		const variantPickerSource = html.getElementById(
			`variant-picker-${sourceSectionId}`,
		)
		const variantPickerDestionation = document.getElementById(
			`variant-picker-${this.dataset.section}`,
		)
		if (!variantPickerSource) return

		const newVariantDataEl = variantPickerSource.querySelector(
			'[data-selected-variant]',
		)
		if (!newVariantDataEl) return

		const newVariantData = variantPickerSource.querySelector(
			'[data-selected-variant]',
		).innerHTML

		const selectedVariant = !!newVariantData ? JSON.parse(newVariantData) : null

		this.currentVariant = selectedVariant

		const oldEl = variantPickerDestionation.querySelector(
			'[data-selected-variant]',
		)
		if (oldEl) {
			oldEl.innerHTML = newVariantData
		}
	}

	updatePickerInnerHtml(html) {
		// attr data-original-section use for Quick view modal
		const currentSectionId = this.dataset.section
		const sourceSectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section

		const variantPickerSource = html.getElementById(
			`variant-picker-${sourceSectionId}`,
		)
		const variantPickerDestination = document.getElementById(
			`variant-picker-${currentSectionId}`,
		)

		if (variantPickerSource && variantPickerDestination) {
			const quickViewModal = this.closest('quick-view-modal')
			if (quickViewModal) {
				variantPickerDestination.innerHTML =
					variantPickerSource.innerHTML.replaceAll(
						sourceSectionId,
						`quickview-${sourceSectionId}`,
					)
			} else {
				variantPickerDestination.innerHTML = variantPickerSource.innerHTML
			}

			;[
				'data-url',
				'data-is-high-variant-product',
				'data-update-url',
				'data-variant-media-display',
			].forEach((attributeName) => {
				const nextValue = variantPickerSource.getAttribute(attributeName)
				if (nextValue !== null) {
					variantPickerDestination.setAttribute(attributeName, nextValue)
				} else {
					variantPickerDestination.removeAttribute(attributeName)
				}
			})

			this.variantData = null
		}
	}
}

if (!customElements.get('variant-selects')) {
	customElements.define('variant-selects', VariantSelects)
}

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
				input.disabled = false
			} else {
				input.classList.add('disabled')
				//input.disabled = true;
			}
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			).value
		})
	}
}

if (!customElements.get('variant-radios')) {
	customElements.define('variant-radios', VariantRadios)
}

class VariantDropdownSelect extends HTMLElement {
	constructor() {
		super()

		this.currentEl = this.querySelector('.dropdown-select__current')
		this.optionsWrapperEl = this.querySelector('.dropdown-select__options')
		this.hiddenInput = this.querySelector("input[type='hidden']")
		if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return

		this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll('li'))
		this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll('input'))
		this.hasColorSwatch = this.currentEl?.classList?.contains(
			'dropdown-select__current--with-color',
		)
		this.isActive = false

		this.optionPosition = this.getOptionPosition()
		this._onCurrentClick = this.onCurrentClick.bind(this)
		this._onKeyUp = this.onKeyUp.bind(this)
		this._onOptionsClick = this.onClickOption.bind(this)
		this._onKeyUpOptions = this.onKeyUpOptions.bind(this)
		this._onOutsideClick = this.onOutsideClick.bind(this)
	}

	connectedCallback() {
		this.currentEl.addEventListener('click', this._onCurrentClick)
		this.currentEl.addEventListener('keyup', this._onKeyUp)
		this.currentEl.addEventListener('dblclick', this.preventDoubleClick)
		this.optionsWrapperEl.addEventListener('click', this._onOptionsClick)
		this.optionsWrapperEl.addEventListener('keyup', this._onKeyUpOptions)
		document.addEventListener('click', this._onOutsideClick)
	}

	disconnectedCallback() {
		this.currentEl.removeEventListener('click', this._onCurrentClick)
		this.currentEl.removeEventListener('keyup', this._onKeyUp)
		this.currentEl.removeEventListener('dblclick', this.preventDoubleClick)
		this.optionsWrapperEl.removeEventListener('click', this._onOptionsClick)
		this.optionsWrapperEl.removeEventListener('keyup', this._onKeyUpOptions)
		document.removeEventListener('click', this._onOutsideClick)
	}

	onCurrentClick(event) {
		event.stopPropagation()
		if (this.isActive) {
			this.onClose()
		} else {
			this.onOpen()
		}
	}

	onKeyUp(event) {
		if (event.code?.toUpperCase() === 'ENTER') {
			event.preventDefault()
			event.stopPropagation()
			if (this.isActive) {
				this.onClose()
			} else {
				this.onOpen()
			}
		}
	}

	preventDoubleClick(event) {
		event.preventDefault()
		event.stopPropagation()
	}

	onClickOption(event) {
		const optionEl = event.target.closest('li')
		const currentValueEl = this.currentEl.querySelector(
			'[data-dropdown-current-value]',
		)

		if (
			!optionEl ||
			!currentValueEl ||
			!this.optionsWrapperEl.contains(optionEl)
		) {
			event.preventDefault()
			return
		}

		const newValue = optionEl.dataset.value

		currentValueEl.textContent = newValue
		this.hiddenInput.value = newValue
		this.inputs.forEach((inputEl) => {
			const isCurrentValue = inputEl.value === newValue
			inputEl.checked = isCurrentValue
			if (isCurrentValue) {
				inputEl.setAttribute('checked', 'true')
			} else {
				inputEl.removeAttribute('checked')
			}
		})

		if (this.hasColorSwatch) {
			const newColor = optionEl.dataset.color
			this.hiddenInput.dataset.colorSwatch = newColor
			this.currentEl.style.setProperty('--swatch-color', newColor)
		}

		const selectedInput = this.inputs.find((inputEl) => inputEl.value === newValue)
		if (selectedInput) {
			selectedInput.dispatchEvent(new Event('change', {bubbles: true}))
		} else {
			this.hiddenInput.dispatchEvent(new Event('change', {bubbles: true}))
		}

		this.onClose()
		this.currentEl.focus()
	}

	onKeyUpOptions(event) {
		if (event.code === 'Escape' && this.isActive) {
			event.preventDefault()
			this.onClose()
			this.currentEl.focus()
		}
	}

	onOpen() {
		document.querySelectorAll('variant-dropdown-select').forEach((dropdown) => {
			if (dropdown !== this && typeof dropdown.onClose === 'function') {
				dropdown.onClose()
			}
		})

		this.optionsWrapperEl.classList.add('active')
		this.currentEl.setAttribute('aria-expanded', 'true')
		this.isActive = true

		const currentIndex = this.inputs.findIndex((inp) =>
			inp.hasAttribute('checked'),
		)
		this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus()
	}

	onClose() {
		this.optionsWrapperEl.classList.remove('active')
		this.currentEl.setAttribute('aria-expanded', 'false')
		this.isActive = false
	}

	onOutsideClick(event) {
		if (!this.isActive || this.contains(event.target)) return
		this.onClose()
	}

	getOptionPosition() {
		const parentFieldset = this.closest('.product-form__controls, .product-form__input')
		return Number(parentFieldset?.dataset?.optionPosition || -1)
	}

	updateCurrentOption(selectedValues = []) {
		// Method is used to synchronize after changes options in sticky bar.
		if (this.optionPosition === -1) return
		const currentValueEl = this.currentEl.querySelector(
			'[data-dropdown-current-value]',
		)

		if (!currentValueEl || !selectedValues || !selectedValues.length) return

		const newValue = selectedValues[this.optionPosition - 1]

		currentValueEl.textContent = newValue
		this.hiddenInput.value = newValue
		this.inputs.forEach((inputEl) => {
			const isCurrentValue = inputEl.value === newValue
			inputEl.checked = isCurrentValue
			if (isCurrentValue) {
				inputEl.setAttribute('checked', 'true')
			} else {
				inputEl.removeAttribute('checked')
			}
		})

		this.optionsEls.forEach((optionEl) => {
			const liDataValue = optionEl.dataset.value
			if (newValue === liDataValue && this.hasColorSwatch) {
				const newColor = optionEl.dataset.color
				this.hiddenInput.dataset.colorSwatch = newColor
				this.currentEl.style.setProperty('--swatch-color', newColor)
			}
		})
	}
}

if (!customElements.get('variant-dropdown-select')) {
	customElements.define('variant-dropdown-select', VariantDropdownSelect)
}
class ProductModel extends DeferredMedia {
	constructor() {
		super();
	}

	loadContent() {
		super.loadContent();

		Shopify.loadFeatures([
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}

	setupModelViewerUI(errors) {
		if (errors) return;

		this.modelViewerUI = new Shopify.ModelViewerUI(
			this.querySelector("model-viewer")
		);

		const $this = this;

		this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
			"click",
			function () {
				if (
					$this
						.closest(".swiper")
						.swiper.slides[
							$this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
				) {
					if (
						!$this
							.closest(".swiper")
							.swiper.slides[
								$this.closest(".swiper").swiper.activeIndex
							].querySelector("model-viewer")
							.classList.contains("shopify-model-viewer-ui__disabled")
					) {
						if (
							$this
								.querySelector(".shopify-model-viewer-ui__button")
								.hasAttribute("hidden")
						) {
							$this.closest(".swiper").swiper.params.noSwiping = true;
							$this.closest(".swiper").swiper.params.noSwipingClass =
								"swiper-slide";
						}
					}
				}
			}
		);

		this.querySelector(
			".shopify-model-viewer-ui__controls-overlay"
		).addEventListener("click", function () {
			if (
				!$this
					.querySelector(".shopify-model-viewer-ui__button")
					.hasAttribute("hidden")
			) {
				$this.closest(".swiper").swiper.params.noSwiping = false;
			}
		});
	}
}
customElements.define("product-model", ProductModel);

(function () {
	const imageMouseParallax = (options) => {
		options = options || {};
		this.nameSpaces = {
			wrapper: options.wrapper || ".parallax",
			layers: options.layers || ".parallax-layer",
			deep: options.deep || "data-parallax-deep",
		};

		this.init = function () {
			var self = this;
			var parallaxWrappers = document.querySelectorAll(this.nameSpaces.wrapper);

			for (var i = 0; i < parallaxWrappers.length; i++) {
				(function (i) {
					parallaxWrappers[i].addEventListener("mousemove", function (e) {
						var x = e.clientX;
						var y = e.clientY;
						var layers = parallaxWrappers[i].querySelectorAll(
							self.nameSpaces.layers
						);

						for (var j = 0; j < layers.length; j++) {
							(function (j) {
								var deep = layers[j].getAttribute(self.nameSpaces.deep);
								var disallow = layers[j].getAttribute("data-parallax-disallow");
								var itemX = disallow && disallow === "x" ? 0 : x / deep;
								var itemY = disallow && disallow === "y" ? 0 : y / deep;

								if (disallow && disallow === "both") return;
								layers[j].style.transform =
									"translateX(" + itemX + "%) translateY(" + itemY + "%)";
							})(j);
						}
					});
				})(i);
			}
		};
		this.init();
		return this;
	};

	document.addEventListener("shopify:section:load", imageMouseParallax);

	imageMouseParallax();
})();

/* Light header on dark bg */
(function () {
	let setLightHeader = () => {
		let articleElement = document.querySelector(".section-slideshow");
		let headerArticle = document.querySelector(".article-template__header");
		let headerWrapper = document.querySelector(".header-wrapper");
		let sectionHeader = document.querySelector(".shopify-section-header");

		let headerLogo =
			document.querySelector(
				".header > .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)"
			) ||
			document.querySelector(
				".header > .header__heading .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)"
			);
		let headerLogoOverlay = document.querySelector(
			".header__heading-logo--overlay"
		);

		if (headerLogoOverlay) {
			if (headerLogo) {
				headerLogo.classList.add("hide");
			}
			headerLogoOverlay.classList.add("show");
		} else {
			if (headerLogo) {
				headerLogo.classList.remove("hide");
			}
		}

		if (
			document
				.querySelectorAll("*[id^='shopify-section-template']")[0]
				.querySelector(".section-under-menu")
		) {
			headerWrapper.classList.add("header-wrapper--under-menu", "container");
			sectionHeader.classList.add("section-header--under-menu");
		} else {
			headerWrapper.classList.remove("header-wrapper--under-menu", "container");
			sectionHeader.classList.remove("section-header--under-menu");
		}

		let heroMedia = document.querySelector(".article-template__hero > .media");

		if (heroMedia) {
			if (heroMedia.classList.contains("article-template__hero-large")) {
				headerArticle.classList.add("article-template__header-large");
			} else {
				headerArticle.classList.remove("article-template__header-large");
			}
		}

		// Checking Interactive section
		const main = document.getElementById("MainContent");
		const sections = main.querySelectorAll(".shopify-section");
		const elementOverlay = sections[0].querySelector(".section--has-overlay");

		sections.forEach((section) => {
			const sectionFirstChild = sections[0].querySelector("div");
			if (
				(sections[0].classList.contains("section--overlay") &&
					sectionFirstChild.classList.contains("color-background-3")) ||
				elementOverlay
			) {
				headerWrapper.classList.add("header-wrapper--overlay");
				if (headerLogoOverlay) {
					if (headerLogo) {
						headerLogo.classList.add("hide");
					}
					headerLogoOverlay.classList.add("show");
				} else {
					if (headerLogo) {
						headerLogo.classList.remove("hide");
					}
				}
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		setLightHeader();
	});

	window.addEventListener("resize", function () {
		setLightHeader();
	});

	setLightHeader();
})();

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener('cart:refresh', () => {
	const sectionsToUpdate = [
		{id: 'cart-icon-bubble', selector: '#cart-icon-bubble'},
		{id: 'CartDrawer', selector: '#CartDrawer'},
		{id: 'main-cart-items', selector: '#main-cart-items .js-contents'},
		{id: 'main-cart-footer', selector: '#main-cart-footer .js-contents'},
		{id: 'CartDrawer-LiveRegionText', selector: '#CartDrawer-LiveRegionText'},
	]

	sectionsToUpdate.forEach((section) => {
		fetch(`${routes.cart_url}?section_id=${section.id}`)
			.then((response) => response.text())
			.then((html) => {
				const parsed = new DOMParser().parseFromString(html, 'text/html')
				const sourceEl = parsed.querySelector(section.selector)
				const destEl = document.querySelector(section.selector)

				if (sourceEl && destEl) {
					destEl.innerHTML = sourceEl.innerHTML
				}
			})
			.catch((err) => {
				console.error(
					`cart:refresh — error updating section ${section.id}`,
					err
				)
			})
	})
})


// CART REFRESH EVENT END
// -----------------------------------------------------------------------------